import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ILitigationAssistantState {
  name: string;
}

const initialState: ILitigationAssistantState = {
  name: '',
};

const litigationAssistantSlice = createSlice({
  name: 'litigationAssistant',
  initialState,
  reducers: {
    setLitigationAssistant: (state, action: PayloadAction<ILitigationAssistantState>) => {
      state.name = action.payload.name;
    },
    setLitigationName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
  },
});

export default litigationAssistantSlice.reducer;

export const { setLitigationName, setLitigationAssistant } = litigationAssistantSlice.actions;
